import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { CheckCircle2 } from "lucide-react";
import { getBikes } from "@/lib/api";
import { Button } from "@/components/ui/button";

export default function Bikes() {
  const [bikes, setBikes] = useState([]);
  const navigate = useNavigate();
  useEffect(() => { getBikes().then(setBikes).catch(() => {}); }, []);
  const openBook = (bike) => navigate(`/book?bike=${bike.id}`);

  return (
    <div className="bg-[#F5F5F0] min-h-screen">
      <div className="max-w-7xl mx-auto px-6 md:px-10 py-16">
        <p className="overline text-[#001A4D] mb-4">Bike Hire · Priced per hour</p>
        <h1 className="font-serif font-light text-5xl md:text-6xl text-[#0A0A0A] mb-4">Pick your ride</h1>
        <p className="text-[#0A0A0A]/60 max-w-xl mb-12" data-testid="bikes-intro">
          Hire by the hour — helmets and locks included. Choose your bike, tell us how long,
          and you're away.{bikes.length > 0 && <> {bikes.reduce((s, b) => s + b.total_qty, 0)} bikes in the fleet across {bikes.length} types.</>}
        </p>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
          {bikes.map((b, i) => {
            return (
              <motion.div
                key={b.id}
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.4, delay: i * 0.05 }}
                data-testid={`bike-card-${b.id}`}
                className="bg-white rounded-2xl overflow-hidden border border-black/5 group flex flex-col"
              >
                <div className="h-56 overflow-hidden bg-neutral-200">
                  <img src={b.image} alt={b.name} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
                </div>
                <div className="p-6 flex flex-col flex-1">
                  <div className="flex items-start justify-between">
                    <h3 className="font-serif text-2xl text-[#0A0A0A]">{b.name}</h3>
                    <p className="font-mono text-lg text-[#001A4D] font-medium whitespace-nowrap">${b.price_per_hour}<span className="text-xs text-[#0A0A0A]/40">/hr</span></p>
                  </div>
                  <p className="text-sm text-[#0A0A0A]/60 mt-2 leading-relaxed flex-1">{b.description}</p>
                  <div className="flex items-center gap-1.5 mt-4 text-sm" data-testid={`bike-availability-${b.id}`}>
                    <CheckCircle2 className="w-4 h-4 text-[#001A4D]" /><span className="text-[#0A0A0A]/70">{b.total_qty} in the fleet · pick your date when booking</span>
                  </div>
                  <Button
                    data-testid={`hire-btn-${b.id}`}
                    onClick={() => openBook(b)}
                    className="mt-5 rounded-full bg-[#001A4D] hover:bg-[#00287A] text-white h-11"
                  >
                    Book this bike
                  </Button>
                </div>
              </motion.div>
            );
          })}
        </div>
      </div>

    </div>
  );
}
